import React from 'react'
import Helmet from 'react-helmet'

import CustomHelmet from '../components/CustomHelmet'
import Hero from '../components/ProgramOverview/Hero'
import DestinationCards from '../components/ProgramOverview/DestinationCards'
import Nav from '../components/ProgramOverview/Nav'
import Quiz from '../components/ProgramOverview/Quiz'



class DestinationLanding extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeNav:'ecuador'
    }
  }

  componentDidMount() {
    let brazilLink = document.querySelector('#Brazil'),
        //senegalLink = document.querySelector('#Senegal'),
        indiaLink = document.querySelector('#India'),
        offset = 420;

    window.addEventListener('scroll', () => {
      let brazilTrigger = (brazilLink.offsetTop - offset),
          //senegalTrigger = (senegalLink.offsetTop - offset),
          indiaTrigger = (indiaLink.offsetTop - offset)

      let doc = document.documentElement,
          top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

      if (top > indiaTrigger) {
        this.state.activeNav != 'india' ? this.setState({activeNav: 'india'}) : null
      }
      else if (top > brazilTrigger) {
        this.state.activeNav != 'brazil' ? this.setState({activeNav: 'brazil'}) : null
      } else {
        this.state.activeNav != 'ecuador' ? this.setState({activeNav: 'ecuador'}) : null
      }
    })

    var ScrollReveal = require('scrollreveal')

    window.setTimeout(() => {
      window.sr = ScrollReveal();
      sr.reveal('.destination-card', { duration: 600 })
    }, 200)
  }

  render() {
    const { data: { page } } = this.props
    const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;

    return (
      <div className="dest">
        <CustomHelmet data={ page.seoData } />
        <Hero title={page.title}/>
        <Nav cards={page.destinationCards} activeNav={this.state.activeNav} />
        <DestinationCards cards={page.destinationCards}/>
        <Quiz
          title={page.quizTitle}
          text={page.quizText}
          link={page.quizLink}
        />
      </div>
    )
  }
}

export default DestinationLanding

export const query = graphql`
  query DestinationsPageQuery {
    page: contentfulDestinationsPage {
      title
      destinationCards {
        destinationName
        link {
          text
          link
        }
        featuredImage {
          file {
            url
          }
          title
        }
        destinationDetails {
          text {
            text
          }
          title
        }
      }
      quizTitle
      quizText
      quizLink {
        text
        link
      }
      seoData {
        id
        pageTitle
        pageDescription {
          id
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          id
          openGraphDescription
        }
        openGraphImage {
          id
          file {
            url
            fileName
            contentType
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/destinations-overview.js